// @flow
import React from 'react'
import ChangePasswordForm from './form'

const ChangePassword = (): any => {
  return (
    <div className='pw-reset-password'>
      <div className='pw-reset-password__header'>
        <i className='icon icon--logo' />
        <h3>Please enter a new password.</h3>
      </div>
      <ChangePasswordForm />
    </div>
  )
}

ChangePassword.displayName = 'ChangePassword'

export default ChangePassword
